<header class="sub-page-layout__header revenueCode__header">
  <div class="revenueCode__header-text h2 h2--semi-bold">Revenue Codes</div>
  <mat-slide-toggle
    class="revenueCode__active-toggle"
    [checked]="activeFilter === 'active'"
    color="primary"
    (change)="showInactiveChanges($event)"
  >
    <div *ngIf="activeFilter !== 'inactive'">Active</div>
    <div *ngIf="activeFilter === 'inactive'">Inactive</div>
  </mat-slide-toggle>
  <button mat-flat-button color="primary" class="revenueCode__add-item" (click)="uploadCodes()" *ngIf="!viewOnly">
    <mat-icon>file_upload</mat-icon> Upload Revenue Codes
  </button>
  <button mat-flat-button color="primary" class="revenueCode__add-item" (click)="addRevenueCode()" *ngIf="!viewOnly">
    <mat-icon>add_circle_outline</mat-icon> Add Revenue Code
  </button>
</header>
<div *ngIf="dataSource && gridConfig" class="lib-grid__grid-container">
  <lib-grid [dataSource]="dataSource" [gridConfiguration]="gridConfig" skipLoadOnInit="true" loadAfterInit="true">
    <div class="">
      <h4>No Revenue Codes Found.</h4>
    </div>
  </lib-grid>
</div>
<footer *ngIf="isImplementation" class="revenueCode__footer">
  <lib-button-loading color="primary" class="revenueCode__button" (clickEvent)="next()" id="nextButton"
    >Next
  </lib-button-loading>
</footer>
